module.exports = __webpack_public_path__ + "img/weixin_icon_white.d3ec0ef7.png";